import { render, staticRenderFns } from "./PendenciesMainView.vue?vue&type=template&id=53d851c2"
import script from "./PendenciesMainView.vue?vue&type=script&lang=js"
export * from "./PendenciesMainView.vue?vue&type=script&lang=js"
import style0 from "./PendenciesMainView.vue?vue&type=style&index=0&id=53d851c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports